import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import _ from 'lodash'

import { allowedContactFields } from '../../helpers'
import { importContacts } from '../../actions'

import { Upload, Button, Icon, message, Tooltip } from 'antd'

class ImportContacts extends Component {
  handleImport = file => {
    const { match: { params }, importContacts } = this.props

    if (file) {
      const rABS = true // true: readAsBinaryString ; false: readAsArrayBuffer

      import('xlsx')
        .then(XLSX => {
          const reader = new FileReader()
          reader.onload = function (e) {
            let data = e.target.result

            if (!rABS) {
              data = new Uint8Array(data)
            }

            const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' })
            let contactsArray = []

            _.forEach(workbook.Sheets, sheet => {
              const sheetContacts = XLSX.utils.sheet_to_json(sheet)
              sheetContacts.forEach(contact => {
                // if there is status defined in column, use it / define status as 0 otherwise
                if (contact.status === null || isNaN(contact.status)) {
                  contact.status = 0
                } else {
                  contact.status = parseInt(contact.status, 10)
                }

                // use only allowed fields
                const allowedFields = [..._.map(allowedContactFields, 'name'), 'status']
                contactsArray.push(_.pick(contact, allowedFields))
              })
            })

            // call the Import function
            importContacts(contactsArray, params.projectId)
          }

          if (rABS) {
            reader.readAsBinaryString(file)
          } else {
            reader.readAsArrayBuffer(file)
          }
        })
        .catch(err => {
          message.error('Problem with network, try again later')
          console.log('XLSX library not loaded' + err)
        })
    }
  }

  render () {
    const { loading } = this.props

    return (
      <Upload showUploadList={false} customRequest={data => this.handleImport(data.file)}>
        <Tooltip
          title={
            <div>
              <b>Allowed columns:</b><br />
              {allowedContactFields.map(field => field.name).join(', ')}
            </div>
          }
        >
          <Button>
            <Icon type={loading.importContacts ? 'loading' : 'upload'} /> Import Contacts
          </Button>
        </Tooltip>
      </Upload>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading
})

const mapDispatchToProps = {
  importContacts
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImportContacts))



// WEBPACK FOOTER //
// ./src/components/Contacts/ImportContacts.js